/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    code: "code",
    em: "em",
    a: "a",
    strong: "strong",
    p: "p",
    ul: "ul",
    li: "li"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Properties"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Properties"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "text"
            }), " or ", _jsx(_components.code, {
              children: "children"
            })]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(required)"
            }), " a heading, can be text or React.Node."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "size"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Define the typography ", _jsx(_components.a, {
              href: "/uilib/typography/font-size",
              children: "font-size"
            }), " by a size ", _jsx(_components.em, {
              children: "type"
            }), ", e.g. ", _jsx(_components.code, {
              children: "x-large"
            }), ". Defaults to the predefined heading sizes."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "level"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Overwrite the automated level handling to use a specific value to ensure correct level hierarchy."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "increase"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " If set to ", _jsx(_components.code, {
              children: "true"
            }), ", the heading level will be incremented by 1."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "decrease"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " If set to ", _jsx(_components.code, {
              children: "true"
            }), ", the heading level will be decremented by 1."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "inherit"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " If set to ", _jsx(_components.code, {
              children: "true"
            }), ", the heading last used level will be inherited. Also from inside a level context."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "reset"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " If set to ", _jsx(_components.code, {
              children: "true"
            }), ", the heading level will be reset to 2. You can give it a custom level if you need to, e.g. ", _jsx(_components.code, {
              children: "reset(1)"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "skip_correction"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " If set to ", _jsx(_components.code, {
              children: "true"
            }), ", the heading will not be corrected and warnings will not be shown. Warnings do not show up in ", _jsx(_components.strong, {
              children: "production builds"
            }), " else either."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "debug"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " If set to ", _jsx(_components.code, {
              children: "true"
            }), ", the content will have a prefix, showing the heading level."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "debug_counter"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " If set to ", _jsx(_components.code, {
              children: "true"
            }), ", the content will have both a prefix and a JSON log attached to both headings and level contexts."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "element"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " define what HTML element should be used. If you use, e.g. a ", _jsx(_components.code, {
              children: "span"
            }), ", then ", _jsx(_components.code, {
              children: "role=\"heading\""
            }), " and ", _jsx(_components.code, {
              children: "aria-level"
            }), " gets set. Defaults to semantic heading element."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "skeleton"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", an overlaying skeleton with animation will be shown."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/uilib/layout/space/properties",
              children: "Space"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " spacing properties like ", _jsx(_components.code, {
              children: "top"
            }), " or ", _jsx(_components.code, {
              children: "bottom"
            }), " are supported."]
          })]
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Properties which do apply to the provider (level context) ", _jsx(_components.code, {
        children: "Heading.Level"
      }), " as well:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "increase"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "decrease"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "inherit"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "reset"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "skip_correction"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "debug"
        })
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
